import styled from 'styled-components';
import { black32, black64 } from '../../styles/colors';
import { margin } from '../../styles/system';
import * as typography from '../../styles/typography';
const Label = /*#__PURE__*/styled.label.withConfig({
  displayName: "Label",
  componentId: "v7lpog-0"
})(["", " ", ";display:block;color:", ";"], typography.formLabel, margin.withDefaults({
  mb: 2
}), props => props.disabled ? black32 : black64);
export { Label };